var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',[_vm._v("Grados")]),_c('GlobalIndex',{attrs:{"permissionRoot":'Grados',"headers":_vm.headers,"payload":'?',"storeModel":_vm.storeModel,"itemsPerPage":_vm.itemsPerPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }